/*----- Export -----*/
import React  from 'react'
import styled from 'styled-components'

/*----- Components -----*/
import AttributeItem from './AttributeItem'

/*----- Commons -----*/
import Device from '../../commons/Device'

/*----- Assets -----*/
import Attr1 from '../../assets/icons/attribute_list/1.svg'
import Attr2 from '../../assets/icons/attribute_list/2.svg'
import Attr3 from '../../assets/icons/attribute_list/3.svg'
import Attr4 from '../../assets/icons/attribute_list/4.svg'
import Attr5 from '../../assets/icons/attribute_list/5.svg'
import Attr6 from '../../assets/icons/attribute_list/6.svg'
import Attr7 from '../../assets/icons/attribute_list/7.svg'
import Attr8 from '../../assets/icons/attribute_list/8.svg'

/*----- Styles -----*/
const StyledAttributeList = styled.div`
	display: grid;
	grid-column-gap: 8px;
	grid-template-columns: repeat(1, 100%);
	padding-right: 16px;
  border-radius: 8px;
	width: 100%;
	@media ${ Device.sm } {
		grid-template-columns: repeat(2, 50%);
	}
	@media ${ Device.xl } {
		grid-template-columns: repeat(4, 25%);
		grid-column-gap: 16px;
		padding-right: 48px;
	}
`

/*----- Export -----*/
const AttributeList = () => (
  <StyledAttributeList className="attributes-list">
    <AttributeItem
      urlIcon = { Attr1 }
      title = "Asesoramiento"
      description = "Te asesoramos para que crezcas como productor"
    />
    <AttributeItem
      urlIcon = { Attr2 }
      title = "Capacitaciones"
      description = "Brindamos capacitaciones de valor a nuestros productores"
    />
    <AttributeItem
      urlIcon = { Attr3 }
      title = "Respaldo"
      description = "Ofrecemos el respaldo que el productor necesita para vincularse con Federación Patronal"
    />
    <AttributeItem
      urlIcon = { Attr4 }
      title = "Estrategia"
      description = "Compartimos estrategias para mejorar tu rentabilidad y el servicio que ofrecés a tu cartera"
    />
    <AttributeItem
      urlIcon = { Attr5 }
      title = "Coworking"
      description = "Ofrecemos un espacio de coworking"
    />
    <AttributeItem
      urlIcon = { Attr6 }
      title = "Plataforma online"
      description = "Disponemos de una plataforma para conectarte virtualmente con nuestros asesores"
    />
    <AttributeItem
      urlIcon = { Attr7 }
      title = "Cartera"
      description = "Más de 100 productores ya se sumaron y aumentaron su cartera de clientes"
    />
    <AttributeItem
      urlIcon = { Attr8 }
      title = "Experiencia"
      description = "Contamos con 25 años de experiencia y de crecimiento continuo en el mercado asegurador "
    />
  </StyledAttributeList>
)
export default AttributeList
